import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // CANCELLED PASSENGERS
  cancelledPassengersLoading: false,
  cancelledPassengers: [],
  cancelledPassengersError: null,
};

export const passengerSlice = createSlice({
  name: "passenger",
  initialState,
  reducers: {
    resetState: (state) => {
      state.createPassengerLoading = false;
      state.createPassengerError = null;
    },

    // CANCELLED PASSENGERS
    cancelledPassengerFetch: (state) => {
      state.cancelledPassengersLoading = true;
      state.cancelledPassengers = [];
      state.cancelledPassengersError = null;
    },
    cancelledPassengerSuccess: (state, action) => {
      state.cancelledPassengersLoading = false;
      state.cancelledPassengers = action.payload;
      state.cancelledPassengersError = null;
    },
    cancelledPassengerError: (state, action) => {
      state.cancelledPassengersLoading = false;
      state.cancelledPassengers = [];
      state.cancelledPassengersError = action.payload;
    },
  },
});

export const passengerActions = passengerSlice.actions;
export const passengerReducers = passengerSlice.reducer;
